<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Hotkeys</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h1>Alle Tastenkombinationen</h1>

  <h2>Global</h2>
  <section class="h-area">
    <hotkey-row *ngFor="let item of globalHotkeys; let i = index" [row]="item" [withBorder]="i < globalHotkeys.length - 1"></hotkey-row>
  </section>
  
  <h2>Ticketübersicht</h2>
  <section class="h-area">
    <hotkey-row *ngFor="let item of ticketOverviewHotkeys; let i = index" [row]="item" [withBorder]="i < ticketOverviewHotkeys.length - 1"></hotkey-row>
  </section>

  <h2>Ticket</h2>
  <section class="h-area">
    <hotkey-row *ngFor="let item of ticketDetailHotkeys; let i = index" [row]="item" [withBorder]="i < ticketDetailHotkeys.length -1"></hotkey-row>
  </section>

  <h2>Boards</h2>
  <section class="h-area">
    <hotkey-row *ngFor="let item of boards; let i = index" [row]="item" [withBorder]="i < boards.length -1"></hotkey-row>
  </section>

  <h2>Ticketzeiten-Übersicht (Wenn ausgewählt)</h2>
  <section class="h-area">
    <hotkey-row *ngFor="let item of ticketTime; let i = index" [row]="item" [withBorder]="i < ticketTime.length -1"></hotkey-row>
  </section>


</ion-content>